import React, { PropTypes } from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import { FormattedNumber, FormattedPlural, intlShape } from 'react-intl';
import { Link } from 'react-router';

import AverageRating from 'AppComponents/AverageRating';

import '../../styles.scss';


const ChargerPreview = (props) => {
  const { charger } = props;
  return (
    <div className='content'>
      <h4>{ charger.title }</h4>

      <p>{ charger.address.line1 || charger.address.line2 || charger.address.city.name }</p>

      { charger.average_rating !== undefined && charger.average_rating > 0 ?
        <Link styleName='rating-link' to={`/charger/${charger.pk}/`}>
          <AverageRating rating={charger.average_rating} />
        </Link>
      : null }

      { charger.reviews !== undefined && charger.reviews.length > 0 ?
        <p>
          <Link to={`/charger/${charger.pk}/`}>
            <FormattedNumber value={charger.reviews.length} />&nbsp;
            <FormattedPlural value={charger.reviews.length} one='review' other='reviews' />
          </Link>
        </p>
      : null }

      <Link
        className='btn btn-primary go-to'
        styleName='go-to'
        to={`/charger/${charger.pk}/`}
      />
    </div>
  );
};

ChargerPreview.propTypes = {
  charger: PropTypes.shape({
    pk: PropTypes.number,
    title: PropTypes.string,
    address: PropTypes.object,
    average_rating: PropTypes.number,
    reviews: PropTypes.array,
  }).isRequired,
  intl: intlShape,
  router: routerShape,
};

ChargerPreview.defaultProps = {
  intl: null,
  router: null,
};

export default ChargerPreview;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Home/components/ChargerPreview/index.jsx